import { render, staticRenderFns } from "./LedgerCodes.vue?vue&type=template&id=7b238951"
import script from "./LedgerCodes.vue?vue&type=script&lang=js"
export * from "./LedgerCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports